export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const DD_MM_YYYY = 'DD.MM.YYYY';
export const D_M_YY = 'D.M.YY';
export const MOMENT_LL = 'LL';
export const DATEPICKER_FORMAT = 'dd.MM.yyyy';
export const MONTHS: any = {
  en: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  de: [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
  ],
  fi: [
    'tammikuu',
    'helmikuu',
    'maaliskuu',
    'huhtikuu',
    'toukokuu',
    'kesäkuu',
    'heinäkuu',
    'elokuu',
    'syyskuu',
    'lokakuu',
    'marraskuu',
    'joulukuu',
  ],
  sv: [
    'Januari',
    'Februari',
    'Mars',
    'April',
    'Maj',
    'Juni',
    'Juli',
    'Augusti',
    'September',
    'Oktober',
    'November',
    'December',
  ],
};

export const WEEKDAYS_SHORT: any = {
  en: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  de: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  fi: ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'],
  sv: ['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö'],
};

export const WEEKDAYS_LONG: any = {
  en: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  de: [
    'Sonntag',
    'Montag',
    'Dienstag',
    'Mittwoch',
    'Donnerstag',
    'Freitag',
    'Samstag',
  ],
  fi: [
    'sunnuntai',
    'maanantai',
    'tiistai',
    'keskiviiko',
    'torstai',
    'perjantai',
    'lauantai',
  ],
  sv: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
};
